<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStoreGetters } from 'dashboard/composables/store';
import { useAlert } from 'dashboard/composables';
import Button from 'dashboard/components-next/button/Button.vue';

const { t } = useI18n();
const getters = useStoreGetters();
const accountId = getters.getCurrentAccountId;

const mcpEndpointUrl = computed(() => {
  const origin = window.location.origin;
  return `${origin}/api/v1/accounts/${accountId.value}/mcp`;
});

function copyUrl() {
  navigator.clipboard.writeText(mcpEndpointUrl.value);
  useAlert(t('INTEGRATION_SETTINGS.MCP_ENDPOINT.COPIED'));
}
</script>

<template>
  <div
    class="flex items-center gap-6 p-6 m-[1px] outline outline-n-container outline-1 bg-n-alpha-3 rounded-md shadow"
  >
    <div
      class="flex h-12 w-12 shrink-0 items-center justify-center bg-gradient-to-br from-n-teal-500 to-n-blue-600 rounded-md"
    >
      <i class="i-lucide-cable text-white text-2xl" />
    </div>
    <div class="flex flex-col flex-1 min-w-0">
      <div class="font-medium text-n-slate-12 text-base font-semibold">
        {{ $t('INTEGRATION_SETTINGS.MCP_ENDPOINT.HEADER') }}
      </div>
      <p class="text-n-slate-11 text-sm mt-0.5">
        {{ $t('INTEGRATION_SETTINGS.MCP_ENDPOINT.DESCRIPTION') }}
      </p>
    </div>
    <div class="flex items-center gap-2 shrink-0">
      <code
        class="text-xs px-3 py-2 rounded-md bg-n-alpha-2 border border-n-weak text-n-slate-12 max-w-xs truncate"
      >
        {{ mcpEndpointUrl }}
      </code>
      <Button
        icon="i-lucide-copy"
        xs
        faded
        :label="$t('INTEGRATION_SETTINGS.MCP_ENDPOINT.COPY')"
        @click="copyUrl"
      />
    </div>
  </div>
</template>
